// extracted by mini-css-extract-plugin
export default {"wrapper":"c_34XJtVtRSg1YBKxFAj","contentWrapper":"_AdqSWdwzwAWOnMa5K9_","title":"u7BAbZpKJ9RWQRJG5KVN","subtitle":"ThprA4JN_Z34HUSku12f","top":"Gvrpqv4slXPY8wakklZc"};